import React from "react";
import { IonContent, IonPage, IonLoading } from "@ionic/react";

const Loading = () => {
  return (
    <IonPage>
      <IonContent>
        <IonLoading isOpen={true} duration={10000} />
      </IonContent>
    </IonPage>
  );
};

export default Loading;
